/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { MsgPackDecoder } from '../../serializer/MsgPackDecoder';
import * as msgpack from 'msgpack5'; // tslint:disable:no-any

/**
 * Encode and decode Crown data based on MsgPack format
 */

export class CrownProtocolMsgPack {
  constructor() {
    this._msgPackDecoder = new MsgPackDecoder();
    this._msgPackEncoder = msgpack();
  }

  encode(data) {
    return this._msgPackEncoder.encode(data);
  }

  decode(data) {
    return this._msgPackDecoder.decode(data);
  }

}
//# sourceMappingURL=CrownProtocolMsgPack.js.map